export const SET_LOADING = 'SET_LOADING';
export const SET_LOADER_DECREMENT = "SET_LOADER_DECREMENT";